// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"F_cm","breadcrumbs__link":"F_cn","breadcrumbs__link__active":"F_cp","breadcrumbs__span":"F_cq"};